import { Stack, Typography } from '@mui/material';
import { OrgManagement } from '@components/OrgManagement';

export function AdminPanel() {
  return (
    <Stack spacing={2}>
      <Typography variant="h5">Access Control</Typography>
      <OrgManagement />
    </Stack>
  );
}
